import { render } from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=template&id=0be66a92&scoped=true&ts=true"
import script from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchOccupationOfJapan.vue?vue&type=style&index=0&id=0be66a92&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be66a92"]])

export default __exports__